import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Link } from 'react-router-dom';

const LegalLinks = ({ className, style }) => (
  <div className={`text-center ${className}`} style={style}>
    <Link to="/privacy" className="LegalLinks_termsLink">
      Privacy Policy
    </Link>

    <span> | </span>

    <Link to="/terms" className="LegalLinks_termsLink">
      Terms of Use
    </Link>

    <span> | </span>

    <Link to="/faq" className="LegalLinks_termsLink">
      <span>FAQs</span>
    </Link>
  </div>
);

LegalLinks.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
}

LegalLinks.defaultProps = {
  className: '',
  style: {}
}

export default LegalLinks;



// WEBPACK FOOTER //
// ./src/components/LegalLinks/LegalLinks.js